/* Ejecuta la llamada para detener los videos que están contenidos en un iframe */
window.stopVideos = function () {
    $("iframe").each(function () {
        this.contentWindow.postMessage('{"event":"stopVideo"}', '*');
    });
    var videos = document.querySelectorAll('video');
    Array.prototype.forEach.call(videos, function (video) {
        if (video.tagName.toLowerCase() === 'video') {
            video.pause();
        }
    });
};
